export default from './FeaturedHead';



// WEBPACK FOOTER //
// ./src/components/FeaturedHead/index.js